module.exports = "https://www.gc-qa.gnp.com.mx/0dde813bc4963c559b5d59aa9bc618a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_google.png
// module id = 8133
// module chunks = 0